"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolePrivilege = exports.Role = exports.RoleSummary = exports.RoleType = void 0;
var RoleType;
(function (RoleType) {
    RoleType["Cdms"] = "CDMS";
    RoleType["Study"] = "STUDY";
    RoleType["System"] = "SYSTEM";
})(RoleType = exports.RoleType || (exports.RoleType = {}));
class RoleSummary {
}
exports.RoleSummary = RoleSummary;
class Role {
}
exports.Role = Role;
class RolePrivilege {
}
exports.RolePrivilege = RolePrivilege;
//# sourceMappingURL=role.js.map